import { Defaults } from 'es-decorators'
import { ItemQuestion } from 'es6/models/item-question'
import { FormView } from 'es6/views/form-view'
import { generateUniqId, getTemplate } from 'helpers/template-helper'
import $ from 'init/jquery'
import { NewsAgreementPopupView } from './news-agreement-popup-view'

/**
 * Вид для формы "Задать вопрос/ответ"
 */
@Defaults({
  formName: 'question-form',
  events: {
    'click .js-anonymous': 'changePersonType',
    'click .js-popup-close': 'closeForm',
    'click .js-cancel-editing': 'closeForm',
    'click .js-send': 'postQuestion',
    'change .comment-block .textarea': 'changeMessage',
    'input textarea': 'renderCounter',
  },
  additionalOptions: ['itemId', 'questionId', 'isAnswer', 'isMobile', 'bodyView'],
})
export class NewsQuestionsFormView extends FormView {
  /**
   * @inheritDoc
   */
  run () {
    this.template = getTemplate('#product-questions-form-template')
    this._initModel()
    this._initEventListeners()
    this.isGuest = !this.user.get('id')
    FormView.prototype.run.apply(this)
  }

  /**
   * Инициализация попапа соглашения
   * @private
   */
  _initAgreementPopup () {
    this.popupView = new NewsAgreementPopupView({
      el: $('.js-agreement-popup'),
      opener: this.$('#question-agreement'),
    })
  }

  /**
   * Инициализация подписки на события
   * @private
   */
  _initEventListeners () {
    this.listenTo(this.model, 'sync', this.success)
    this.listenTo(this.model, 'error', this.error)
  }

  /**
   * Инициализация модели.
   * @private
   */
  _initModel () {
    this.model = new ItemQuestion({
      item_id: this.itemId,
      is_anonymously: Boolean(this.personType),
      message: '',
      item_question_id: this.questionId || null,
      user_name: null,
    })
  }

  /**
   * Отправка вопроса/ответа.
   * @param {Event} e
   */
  postQuestion (e) {
    e.preventDefault()
    this.$('.js-send').attr('disabled', true)
    this.model.save({ item_question_status_id: 1 })
  }

  /**
   * Заполнение ошибок.
   * @param {Array} errors массив ошибок формы
   */
  fillErrors (errors) {
    errors.forEach(error => {
      this.$(`#${this.formName}-${error.field}-error`).text(error.message)
      this.$(`#${this.formName}-${error.field}`).addClass('error')
    })
  }

  /**
   * Изменение сообщения в модели.
   * @param {Event} e
   */
  changeMessage (e) {
    let messageField = this.$(e.currentTarget)
    this.model.set('message', messageField.val())
  }

  /**
   * Изменение типа пользователя (анон/не анон).
   * @param {Event} e
   */
  changePersonType (e) {
    const target = $(e.currentTarget)
    this.personType = this.isMobile ? target.prop('checked') : target.data('value')
    this.model.set('is_anonymously', this.personType)
  }

  /**
   * Скрытие формы.
   * @param {Event} e Событие клика по закрывающему элементу.
   */
  closeForm (e) {
    this.$el.addClass('not_display')
  }

  /**
   * @inheritDoc
   */
  render () {
    this.$el
      .html(this.template({
        isAnswer: this.isAnswer,
        userIsGuest: this.isGuest,
        isAnonymous: this.personType,
      }))
      .removeClass('not_display')
    // Присваивание label радиокнопкам уникального ID
    if (this.isMobile) {
      let uniqIdPublicName = generateUniqId('public_my_name')
      this.$('#public_my_name')
        .attr('id', uniqIdPublicName)
        .next('[for="public_my_name"]')
        .attr('for', uniqIdPublicName)
      let uniqIdAnonName = generateUniqId('public_anonym')
      this.$('#public_anonym')
        .attr('id', uniqIdAnonName)
        .next('[for="public_anonym"]')
        .attr('for', uniqIdAnonName)
      this.$('.js-message-field').val(this.model.get('message'))
    } else {
      this._initAgreementPopup()
    }
  }

  /**
   * Действия после успешной отправки.
   * @param {Object} response
   */
  success (response) {
    this.$('.js-send').attr('disabled', false)
    let newResponse = {
      response: response.toJSON(),
      isAnswer: this.isAnswer,
      el: this.el,
    }
    this._initModel()
    this._initEventListeners()
    this.$('.comment-block .textarea').val('')
    if (this.isAnswer && !this.isMobile) {
      this.closeForm()
    }
    FormView.prototype.success.apply(this)
    this.trigger('newQuestionAnswer', newResponse)
  }

  /**
   * @inheritDoc
   */
  error (model, response) {
    this.$('.js-send').attr('disabled', false)
    super.error(model, response)
  }
}
